import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: { backgroundColor: '#373737', color: '#fff' },
      },
    },
  },
  palette: {
    primary: {
      light: '#ffbd80',
      main: '#ff8c52',
      dark: '#c75d26',
    },
  },
});

export const sellTheme = responsiveFontSizes(theme);
